import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import NewRecipeDto from '../../../../components/model/NewRecipeDto';
import RecipeModel from '../../../../components/model/RecipeModel';
import { useAlert } from 'react-alert';
import { RecipeFormComponent } from './RecipeFormComponent';
import { RecipeFormTable } from './RecipeFormTable';
import { addRecipeProduct, getNewRecipe, getRecipeToUpdate, removeRecipeProduct, saveRecipe } from './RecipeService';

const RecipeForm = () => {
    const { t } = useTranslation('recipe');
    const location = useLocation();
    let urlPathState = location.state;
    const isEditing = urlPathState !== null;
    const isCopy = isEditing && urlPathState.copy;
    const alert = useAlert();
    const navigate = useNavigate();
    const [newRecipe, setNewRecipe] = useState(NewRecipeDto);
    const [productsList, setProductsList] = useState([{ id: -1, name: t('common:SELECT') }]);
    const [recipe, setRecipe] = useState(RecipeModel.initModel);
    const [recipeLoaded, setRecipeLoaded] = useState(false);

    useEffect(() => {
        if (isEditing) {
            getRecipeToUpdate(urlPathState.id)
                .then((response) => {
                    setRecipeLoaded(true)
                    loadSetup(response)
                })
                .catch(() => alert.error(t('alert:loadingError')))
                .finally(() => setTimeout(() => {
                    setRecipeLoaded(false)
                }), 1000);
        } else {
            getNewRecipe()
                .then((response) => loadSetup(response))
                .catch(() => alert.error(t('alert:loadingError')));
        }
    }, [isEditing]);

    const loadSetup = (response) => {
        let recipe = isCopy ? prepareCopy(response) : response.data;
        setProductsList([{ id: -1, name: t('common:SELECT') }]);
        setProductsList(productsList.concat(response.data.listOfProducts.map(it => ({ id: it.id, name: it.title }))));
        setNewRecipe(recipe);
        setRecipe(recipe.recipeDto);
    };

    const prepareCopy = (response) => {
        let recipe = {
            ...response.data.recipeDto,
            id: null,
            title: t('common:copy') + response.data.recipeDto.title };
        return { ...response.data, recipeDto: recipe };
    };


    const handleSubmit = (recipe) => {
        let recipeDto = newRecipe.recipeDto;
        saveRecipe({
            ...recipeDto,
            title: recipe.title,
            recipeText: recipe.recipeText,
            dynamicQuantities: recipe.dynamicQuantities,
            recipeOutput: recipe.recipeOutput
        }).then(() => {
                alert.success(t('alert:saveSuccess'));
                navigate('/recipe');
            })
            .catch(() => alert.error(t('alert:saveError')));
    };

    const addProduct = (product, values) => {
        addRecipeProduct(mapAddProduct(values), product.id)
            .then((response) => mapResponse(response))
            .catch(() => alert.error(t('alert:loadingError')));
    };

    const removeFormList = (recipeItem) => {
        removeRecipeProduct(mapRemoveProduct(), recipeItem.product.id)
            .then((response) => mapResponse(response))
            .catch(() => alert.error(t('alert:loadingError')));
    };

    const mapResponse = (response) => {
        let temp = [{ id: -1, name: t('common:SELECT') }];
        temp = temp.concat(response.data.listOfProducts.map(it => ({ id: it.id, name: it.title })));
        setProductsList(temp);
        setRecipe(response.data.recipeDto);
        setNewRecipe(response.data);
    };

    const mapAddProduct = (values) => {
        let mappedRecipeDto = {
            ...newRecipe.recipeDto,
            title: document.getElementById('recipe-title').value,
        };
        return {
            ...newRecipe,
            recipeDto: mappedRecipeDto,
            productAndQuantityDto: {
                id: null,
                product: null,
                amountGross: values.amountGross,
                amountGrossCradle: values.amountGrossCradle,
                amountNet: values.amountNet,
                amountNetCradle: values.amountNetCradle,
            },
        };
    };

    const mapRemoveProduct = () => {
        let mappedRecipeDto = {
            ...newRecipe.recipeDto,
            title: document.getElementById('recipe-title').value,
        };
        return {
            ...newRecipe,
            recipeDto: mappedRecipeDto,
        };
    };

    const cancelAction = () => {
        navigate('/recipe');
    };

    return (
        <div style={{ padding: '20px' }}>
            <h3 className='center'>{isEditing ? t('update') : t('headers:newRecipe')}</h3>
            <div className={'recipeComponents'}>
                <div style={{ width: '25%' }}>
                    <RecipeFormComponent
                        recipe={recipe}
                        addProduct={addProduct}
                        productsList={productsList}
                        onClose={cancelAction}
                        handleSubmit={handleSubmit}
                        recipeLoaded={recipeLoaded} />
                </div>
                <div style={{ width: '74%' }}>
                    <RecipeFormTable recipeData={recipe} onRemove={removeFormList} />
                </div>
            </div>
        </div>
    );
};

export default RecipeForm;
